<script setup lang="ts">
  import { computed } from 'vue'

  type BadgeType = 'info' | 'warning' | 'error' | 'success'
  type BadgeConfig = { background: string; color: string }

  const props = defineProps<{
    type?: BadgeType
    solid?: boolean
  }>()

  const configMap: Record<BadgeType, BadgeConfig> = {
    info: { background: 'bg-blue-95', color: 'text-blue-50' },
    warning: { background: 'bg-orange-95', color: 'text-orange-50' },
    error: { background: 'bg-red-95', color: 'text-red-50' },
    success: { background: 'bg-green-95', color: 'text-green-50' },
  }

  const solidConfigMap: Record<BadgeType, BadgeConfig> = {
    info: { background: 'bg-blue-50', color: 'text-white' },
    warning: { background: 'bg-orange-50', color: 'text-white' },
    error: { background: 'bg-red-50', color: 'text-white' },
    success: { background: 'bg-green-40', color: 'text-white' },
  }

  const config = computed<BadgeConfig>(() => (props.solid ? solidConfigMap : configMap)[props.type ?? 'info'])
</script>

<template>
  <span
    class="inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap select-none"
    :class="[config.background, config.color]"
  >
    <slot></slot>
  </span>
</template>
